var map = {
	"./image01.png": 125,
	"./image02.png": 126,
	"./image03.png": 127,
	"./image04.png": 128,
	"./image05.png": 129,
	"./image06.png": 130,
	"./image07.png": 131,
	"./image08.png": 132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;